import { render, staticRenderFns } from "./VinGoodsList.vue?vue&type=template&id=2a56fa0f&scoped=true"
import script from "./VinGoodsList.vue?vue&type=script&lang=js"
export * from "./VinGoodsList.vue?vue&type=script&lang=js"
import style0 from "./VinGoodsList.vue?vue&type=style&index=0&id=2a56fa0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56fa0f",
  null
  
)

export default component.exports